
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class VendorsGrid extends Serenity.EntityGrid<VendorsRow, any> {
        protected getColumnsKey() { return VendorsColumns.columnsKey; }
        protected getDialogType() { return VendorsDialog; }
        protected getIdProperty() { return VendorsRow.idProperty; }
        protected getInsertPermission() { return VendorsRow.insertPermission; }
        protected getLocalTextPrefix() { return VendorsRow.localTextPrefix; }
        protected getService() { return VendorsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}